import * as React from 'react'
import { useFormikContext } from 'formik'
import Box from '@mui/material/Box'

import { SideDrawerForm } from '@sales-center/components'

import { Title } from './Title'
import { TypeSelect } from './TypeSelect'
import { DropdownOptionList } from './DropdownOptions'
import type { CustomFieldFormModel } from '../typings'

type Props = {
  isUpdate: boolean
  onClose: () => void
}

export function FormFields(props: Props) {
  const { isUpdate, onClose } = props

  const {
    dirty,
    isValid,
    submitForm,
    isSubmitting,
    values: { fieldType },
  } = useFormikContext<CustomFieldFormModel>()

  const disableSave = !dirty || isSubmitting || !isValid

  const showDropdownOptions =
    fieldType === 'DropdownSingleSelect' || fieldType === 'DropdownMultiSelect'

  return (
    <SideDrawerForm
      onCancel={onClose}
      onSave={submitForm}
      disableSave={disableSave}
    >
      <Box p={2} display="flex" flexDirection="column">
        <Title />

        <TypeSelect isUpdate={isUpdate} />

        {showDropdownOptions && <DropdownOptionList />}
      </Box>
    </SideDrawerForm>
  )
}
